<template lang="pug">
    .modal-overlay(v-if='show' @click.self='closeModal')
        .modal-content
            h3 Criar tipo de documento
            form(@submit.prevent='submitForm')
                .form-group
                    label(for='nome') Nome:
                    input(type='text', v-model='document.nome', id='nome', required)
                .form-group
                    label(for='descricao') Descrição:
                    input(type='text', v-model='document.descricao', id='descricao')
                .form-group
                    label(for='ativo') Ativo:
                    select(v-model='document.ativo', id='ativo')
                        option(value='true') Ativo
                        option(value='false') Não Ativo
                .form-actions
                    .pull-left
                        button(type='button', @click='closeModal', style='margin-right: 290px')
                            i.fa.fa-times
                            |  Cancelar
                    .pull-right
                        button(type='submit', style='margin-left: 20px')
                            i.fa.fa-plus
                            |  Salvar
</template>

<script>
import { criarTipoDocumento } from '@/services/tipo-documento.service';

export default {
    name: 'CriacaoDocumentModal',
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            document: {
                nome: '',
                descricao: '',
                ativo: 'true'  // Define o valor padrão como 'true'
            }
        };
    },
    methods: {
        async submitForm() {
            // Converte 'ativo' para booleano para o backend
            const ativoBoolean = this.document.ativo === 'true';
            try {
                await criarTipoDocumento(this.document.nome, this.document.descricao, ativoBoolean);
                this.$emit('create');  // Emitir evento de criação
                this.closeModal();     // Fecha o modal após a criação
            } catch (error) {
                console.error('Erro ao criar tipo de documento:', error);
            }
        },
        closeModal() {
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    max-width: 500px;
    width: 100%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h3 {
    margin-top: 0;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 15px;
}

label {
    display: block;
    margin-bottom: 5px;
}

input[type='text'] {
    width: 100%;
    height: 30px;
    padding: 0px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

select {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

button {
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

button[type='submit'] {
    background-color: var(--primary-green);
    color: #fff;
}

button[type='button'] {
    background-color: #ccc;
    color: #000;
}
</style>
